import HttpRequest from '@/libs/axios'
import { getToken } from "@/libs/util";

import config from '@/config'
const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.pro
const cacheOptions = {}
const optionsApis = {}
const optionsApiDone = {}
const optionsTemp = {}
// const env = process.env.NODE_ENV
// const baseUrl = config.baseUrl[env]
const axios = new HttpRequest(baseUrl)
export default axios

export const tableApis = {}

export function buildApi(params) {
	let apis = {}
	let get = params.get || []
	let post = params.post || []
	let put = params.put || []
	let upload = params.upload || []
	let del = params.del || []
	let curd = params.curd
	let options = params.options || {}
	let desc = params.desc || {}
	if (curd) Object.assign(apis, {
		list: handleMethod(curd, 'get'),
		add: handleMethod(curd, 'post'),
		detail: handleMethod(curd + '/:id', 'get'),
		update: handleMethod(curd + '/:id', 'put'),
		del: handleMethod(curd + '/:id', 'delete'),
	})
	function handle(t, method) {
		let url = t.split('&')
		let lastName = url[0].split('/').slice(-1)
		let name = url.length === 2 ? url[1] || 'get' + lastName : lastName
		apis[name] = handleMethod(url[0], method)
	}
	get.forEach(t => {
		handle(t, 'get')
	})
	post.forEach(t => {
		handle(t, 'post')
	})
	put.forEach(t => {
		handle(t, 'put')
	})
	del.forEach(t => {
		handle(t, 'delete')
	})
	upload.forEach(t => {
		handle(t, 'upload')
	})
	Object.keys(options).forEach(name => {
		if (optionsApis[name]) {
			return console.error('存在相同的公共options：' + name);
		}
		optionsApis[name] = async function (field) {
			try {
				// console.log('执行Options',name);
				let data = JSON.stringify(field.apiData || {})
				let cacheName = name + data
				if (apis[name]) {
					cacheOptions[cacheName] = await options[name](apis[name], {
						apis,
						field,
						data: field.apiData,
						options: cacheOptions
					})
				} else {
					cacheOptions[cacheName] = await options[name]({
						apis,
						field,
						options: cacheOptions
					})
				}
				// console.log('执行完毕Options',name);
				return cacheOptions[cacheName]
			} catch (e) {
				//TODO handle the exception
				optionsApiDone[cacheName] = false
				throw e
			}

		}
		tableApis[name] = { desc: desc[name] }
	})
	return apis
}

export async function optionsApi(field, name) {
	let data = JSON.stringify(field.apiData || {})
	let cacheName = name + data
	try {
		if (optionsApiDone[cacheName] || cacheOptions[cacheName]) {
			// console.log(cacheOptions[cacheName] ? '存在缓存' : '获取中', name, cacheName, cacheOptions);
			if (!cacheOptions[cacheName]) {
				if (!optionsTemp[cacheName]) optionsTemp[cacheName] = []
				optionsTemp[cacheName].push(field)
				return
			}
			field.options = field.handleOptions ? field.handleOptions({ field, options: cacheOptions[cacheName] }) : cacheOptions[cacheName]
			optionsTemp[cacheName] && optionsTemp[cacheName].forEach(temp => {
				temp.options = temp.handleOptions ? temp.handleOptions({ field, options: cacheOptions[cacheName] }) : cacheOptions[cacheName]
			})
			optionsTemp[cacheName] = []
			return cacheOptions[cacheName]
		}
		if (!optionsApis[name]) {
			return console.error('未存在公共Options');
		}
		optionsApiDone[cacheName] = true
		optionsApis[name](field).then(res => {
			field.options = field.handleOptions ? field.handleOptions({ field, options: res }) : res
			optionsTemp[cacheName] && optionsTemp[cacheName].forEach(temp => {
				temp.options = temp.handleOptions ? temp.handleOptions({ field, options: res }) : res
			})
			optionsTemp[cacheName] = []
		}).catch(e => {
			console.error('获取失败Options' + name, e);
		})
	} catch (e) {
		//TODO handle the exception
		console.error(e);
	}

}

export function optionsCommonApi(commons) {
	let keys = []
	commons.forEach((key, field) => {
		if (cacheOptions[key]) {
			field.options = field.handleOptions ? field.handleOptions({ field, options: cacheOptions[key] }) : cacheOptions[key]
		} else keys.push(key)
	})
	keys.length && axios.request({
		url: "/share/getSelectType",
		method: "post",
		data: {
			selectType: keys,
		},
	}).then(res => {
		commons.forEach((key, field) => {
			field.options = field.handleOptions ? field.handleOptions({ field, options: res.data.payload[key] }) : res.data.payload[key]
			cacheOptions[key] = res.data.payload[key]
		})
	})
}

function JsonToFormData(json) {
	console.log(json);
	let formData = new FormData();
	for (let key in json) {
		if (json[key] instanceof Array) {
			json[key].forEach(item => {
				formData.append(key + '[]', item);
			})
		} else {
			formData.append(key, json[key]);
		}
	}
	return formData;
}



function handleMethod(path, method) {
	let url = ''
	switch (method) {
		case 'post':
			return (data) => axios.request({
				url: path.replace(/(?::([a-z]+))/g, function () {
					return data[arguments[1]]
				}),
				method: "Post",
				data
			});
			break;
		case 'put':
			return (data) => axios.request({
				url: path.replace(/(?::([a-z]+))/g, function () {
					return data[arguments[1]]
				}),
				method: "Put",
				data
			});
			break;
		case 'delete':
			return (data) => axios.request({
				url: path.replace(/(?::([a-z]+))/g, function () {
					return data[arguments[1]]
				}),
				method: "Delete",
				data
			});
			break;
		case 'upload':
			return (data) => {
				if (data instanceof Object) {
					data = JsonToFormData(data)
				}
				return axios.request({
					url: path.replace(/(?::([a-z]+))/g, function () {
						return data[arguments[1]]
					}),
					method: "Post",
					data,
					headers: {
						"Content-Type": "multipart/form-data",
						Authorization: getToken()
					}
				});
			}
			break;
		default:
			return (params) => axios.request({
				url: path.replace(/(?::([a-zA-Z_]+))/g, function () {
					return params[arguments[1]]
				}),
				method: "GET",
				params
			});
			break;
	}
}